import { createDefault } from "../../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "商品状態区分", enum: "PRODUCT_CONDITION_TYPES" },
  { value: 2, text: "返品数", enum: "RETURN_QUANTITY" },
  { value: 3, text: "倉庫", enum: "SHIPPING_WAREHOUSE" },
  { value: 5, text: "メーカー検品結果", enum: "MAKER_INSPECTION_RESULT" },
  { value: 6, text: "メーカー検品数", enum: "MAKER_INSPECTION_QUANTITY" },
]);
